var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-cover h-full pb-10 bg-opacity-10",
      style: { backgroundImage: `url(${_vm.image})` },
    },
    [
      _c("div", { staticClass: "max-w-6xl mx-auto p-4 lg:px-8 xl:px-0" }, [
        _c(
          "div",
          { staticClass: "max-w-2xl mx-auto mt-10 bg-white rounded-md" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex justify-center text-gray-600 font-semibold text-xl md:p-6 p-4",
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("registration-for-consultant-individual")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("main-register", {
              on: { registerSuccess: _vm.mainRegisterSuccess },
            }),
            _vm._v(" "),
            _c("ValidationObserver", {
              attrs: { slim: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, invalid }) {
                    return [
                      _c(
                        "form",
                        {
                          attrs: { novalidate: "" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return handleSubmit(_vm.onSubmit)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "grid grid-cols-2 bg-white rounded-md p-6 gap-4",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-start col-span-2 text-gray-600 font-semibold text-xl",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("additional-information")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md:col-span-1 col-span-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block mb-1 text-sm font-medium text-gray-700",
                                      attrs: { for: "activity-type" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("area-of-consultancy"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      options: _vm.activities,
                                      disabled: !_vm.isMainRegister,
                                      searchable: false,
                                      label: "title",
                                      value: "id",
                                      reduce: (activity) => activity.id,
                                      multiple: true,
                                    },
                                    model: {
                                      value: _vm.form.activitytypes,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "activitytypes", $$v)
                                      },
                                      expression: "form.activitytypes",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md:col-span-1 col-span-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block mb-1 text-sm font-medium text-gray-700",
                                      attrs: { for: "field" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "area-of-agriculture-and-environment"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      options: _vm.agrocultureAreas,
                                      disabled: !_vm.isMainRegister,
                                      searchable: false,
                                      label: "title",
                                      value: "id",
                                      reduce: (agro) => agro.id,
                                      multiple: true,
                                    },
                                    model: {
                                      value: _vm.form.agrocultureareas,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "agrocultureareas",
                                          $$v
                                        )
                                      },
                                      expression: "form.agrocultureareas",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md:col-span-1 col-span-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block mb-1 text-sm font-medium text-gray-700",
                                      attrs: { for: "workplace" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("workplace")))]
                                  ),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    attrs: { name: "workplace", mode: "eager" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.additional.workplace,
                                                    expression:
                                                      "additional.workplace",
                                                  },
                                                ],
                                                staticClass:
                                                  "focus:outline-none appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                                class:
                                                  errors.length > 0
                                                    ? "border-red-400"
                                                    : _vm.form.workplace
                                                    ? "border-green-600"
                                                    : "border-gray-300",
                                                attrs: {
                                                  type: "text",
                                                  name: "workplace",
                                                  id: "workplace",
                                                  disabled: !_vm.isMainRegister,
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.additional.workplace,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.additional,
                                                      "workplace",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "block text-sm mb-1 font-medium text-gray-700",
                                    attrs: { for: "degree" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("last-received-degree")) +
                                        "*"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.additional.last_degree,
                                        expression: "additional.last_degree",
                                      },
                                    ],
                                    staticClass:
                                      "focus:outline-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm border-gray-300",
                                    attrs: {
                                      name: "option",
                                      disabled: !_vm.isMainRegister,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.additional,
                                          "last_degree",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  _vm._l(_vm.degrees, function (degree, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: degree },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(degree) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md:col-span-1 col-span-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block mb-1 text-sm font-medium text-gray-700",
                                      attrs: { for: "experience" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("experience")))]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.additional.experience_year,
                                        expression:
                                          "additional.experience_year",
                                      },
                                    ],
                                    staticClass:
                                      "focus:outline-none appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                    attrs: {
                                      name: "experience",
                                      id: "experience",
                                      type: "number",
                                      min: 0,
                                      max: 80,
                                      disabled: !_vm.isMainRegister,
                                    },
                                    domProps: {
                                      value: _vm.additional.experience_year,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.additional,
                                          "experience_year",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md:col-span-1 col-span-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block mb-1 text-sm font-medium text-gray-700",
                                      attrs: { for: "tin" },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("tin")) + "*")]
                                  ),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "tin",
                                      rules: { required: true, min: 9, max: 9 },
                                      mode: "eager",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.additional.tin,
                                                    expression:
                                                      "additional.tin",
                                                  },
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: "#########",
                                                    expression: "'#########'",
                                                  },
                                                ],
                                                staticClass:
                                                  "focus:outline-none appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                                class:
                                                  errors.length > 0
                                                    ? "border-red-400"
                                                    : _vm.form.tin
                                                    ? "border-green-600"
                                                    : "border-gray-300",
                                                attrs: {
                                                  type: "text",
                                                  name: "tin",
                                                  id: "tin",
                                                  disabled: !_vm.isMainRegister,
                                                },
                                                domProps: {
                                                  value: _vm.additional.tin,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.additional,
                                                      "tin",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md:col-span-1 col-span-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block mb-1 text-sm font-medium text-gray-700",
                                      attrs: { for: "resume" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("upload-resume")) +
                                          "(PDF)*(Word)"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "file",
                                    staticClass:
                                      "focus:outline-none appearance-none block w-full px-3 py-1 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm border-gray-300",
                                    attrs: {
                                      "aria-describedby": "file_input_help",
                                      id: "resume",
                                      accept:
                                        "application/pdf,.doc,.docx,application/msword",
                                      type: "file",
                                      disabled: !_vm.isMainRegister,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.mediaChange($event, "resume")
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md:col-span-1 col-span-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "block mb-1 text-sm font-medium text-gray-700",
                                      attrs: { for: "diploma" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("upload-diploma")) +
                                          "(PDF)*"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "file",
                                    staticClass:
                                      "focus:outline-none appearance-none block w-full px-3 py-1 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm border-gray-300",
                                    attrs: {
                                      "aria-describedby": "file_input_help",
                                      id: "diploma",
                                      accept: "application/pdf",
                                      type: "file",
                                      disabled: !_vm.isMainRegister,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.mediaChange(
                                          $event,
                                          "diploma"
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.is_otherone
                                ? _c(
                                    "div",
                                    { staticClass: "md:col-span-1 col-span-2" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "block mb-1 text-sm font-medium text-gray-700",
                                          attrs: { for: "workplace" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("area-of-consultancy") +
                                                "  other"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "workplace",
                                          rules: "required",
                                          mode: "eager",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.additional
                                                            .otherarea,
                                                        expression:
                                                          "additional.otherarea",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "focus:outline-none appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                                    class:
                                                      errors.length > 0
                                                        ? "border-red-400"
                                                        : _vm.additional
                                                            .otherarea
                                                        ? "border-green-600"
                                                        : "border-gray-300",
                                                    attrs: {
                                                      type: "text",
                                                      name: "workplace",
                                                      id: "workplace",
                                                      disabled:
                                                        !_vm.isMainRegister,
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.additional
                                                          .otherarea,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.additional,
                                                          "otherarea",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.is_othertwo
                                ? _c(
                                    "div",
                                    { staticClass: "md:col-span-1 col-span-2" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "block mb-1 text-sm font-medium text-gray-700",
                                          attrs: { for: "workplace" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "area-of-agriculture-and-environment"
                                              ) + "  other"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "workplace",
                                          rules: "required",
                                          mode: "eager",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.additional
                                                            .env_otherarea,
                                                        expression:
                                                          "additional.env_otherarea",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "focus:outline-none appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 sm:text-sm",
                                                    class:
                                                      errors.length > 0
                                                        ? "border-red-400"
                                                        : _vm.additional
                                                            .env_otherarea
                                                        ? "border-green-600"
                                                        : "border-gray-300",
                                                    attrs: {
                                                      type: "text",
                                                      name: "workplace",
                                                      id: "workplace",
                                                      disabled:
                                                        !_vm.isMainRegister,
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.additional
                                                          .env_otherarea,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.additional,
                                                          "env_otherarea",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: {
                                  name: "checked",
                                  rules: "checked",
                                  mode: "eager",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({}) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center mt-2 col-span-2",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.isAgree,
                                                    expression: "isAgree",
                                                  },
                                                ],
                                                staticClass:
                                                  "h-5 w-5 text-green-600 focus:ring-green-600 border-gray-300 rounded",
                                                attrs: {
                                                  name: "termsOfUse",
                                                  type: "checkbox",
                                                  disabled: !_vm.isMainRegister,
                                                },
                                                domProps: {
                                                  value: true,
                                                  checked: Array.isArray(
                                                    _vm.isAgree
                                                  )
                                                    ? _vm._i(
                                                        _vm.isAgree,
                                                        true
                                                      ) > -1
                                                    : _vm.isAgree,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.isAgree,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = true,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.isAgree =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.isAgree = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.isAgree = $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "ml-2 block text-gray-600 text-base",
                                                  attrs: { for: "termsOfUse" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t("i-agree-with")
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-green-600 border-b border-green-600",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "terms-of-use"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "col-span-2 rounded-md py-3 mt-6",
                                  class: invalid
                                    ? "bg-gray-300"
                                    : "bg-green-600 hover:bg-green-700 text-white",
                                  attrs: { disabled: invalid },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("register")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }